<template>
    <div ref="journeyDetailsCard">
        <CustomCard
            :title="$t('journeyTitle', {firstname: booking.Booking.LeadPassenger.Firstname})"
            :sub-title="$t('journeySubtitle')"
            :options="cardOptions"
            :card-media-image="imageUrl"
            ref="fareBreakdownCard"
            :card-media-image-height="mapHeight">
            <template v-slot:cardCustomContent>
                <div class="grid grid-cols-12 py-2 px-4">
                    <div class="col-span-8">
                        <div class="mb-2">
                            <strong class="text-sm block primary">{{ $t('journeyDate') }}</strong>
                            {{ bookingDate }}
                        </div>
                        <div v-for="(stop, key) in booking.Booking.BookingStops" class="mb-2" :conversation="stop" :key="key">
                            <strong class="text-sm block primary" v-if="key == 0">{{ $t('from') }}</strong>
                            <strong class="text-sm block primary" v-if="key == booking.Booking.BookingStops.length - 1">{{ $t('to') }}</strong>
                            <strong class="text-sm block primary" v-if="key !== 0 && key !== booking.Booking.BookingStops.length - 1">{{ $t('via') }}</strong>
                            {{ stop.StopSummary }}
                        </div>

                        <div class="my-2">
                            <strong class="text-sm block primary">{{ $t('totalCost') }}</strong>
                            <span class="t-l font-bold">
                                {{ booking.BookingFinance.Total | formatCurrency }}
                            </span>
                        </div>
                    </div>
                    <div class="col-span-4">
                        <div class="mb-2">
                            <strong class="text-sm block primary">{{ $t('bookingId') }}</strong>
                            {{ booking.Booking.LocalId }}
                        </div>
                        <div class="mb-2">
                            <strong class="text-sm block primary">{{ $t('vehicleType') }}</strong>
                            {{ booking.Booking.VehicleType.Name }}
                        </div>
                        <div class="mb-2">
                            <strong class="text-sm block primary">{{ $t('distance') }}</strong>
                            {{ booking.BookingFinance.EstimatedDistance | formatNumber }}
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:cardExpandedContent>
                <FareBreakdown v-if="!isMetered" :booking="booking.BookingFinance" />
            </template>
        </CustomCard>
    </div>
</template>

<script>
import {formatDate} from '@/utils/helpers';
import CustomCard from '@/components/CustomCard';
import FareBreakdown from '@/components/FareBreakdown';

export default {
    name: 'JourneyDetails',
    props: {
        booking: {
            type: Object
        },
        isMetered: {
            type: Boolean
        }
    },
    components: {
        CustomCard,
        FareBreakdown
    },
    data() {
        return {
            imageUrl: this.booking.Booking.ImageUrl,
            cardOptions: {
                expandedContentTitle: this.$t('fareBreakdown'),
                cardInfoLocation: 'middle',
                expandText: this.$t('expand'),
                collapseText: this.$t('collapse')
            },
            bookingDate: formatDate(this.booking.Booking.BookedDateTime, 'DD/MM/yyyy HH:mm'),
            passengerName: `${this.booking.Booking.LeadPassenger.Firstname}  ${this.booking.Booking.LeadPassenger.Surname}`,
            mapHeight: 200
        };
    },
    methods: {
        adjustMapToWidth() {
            setTimeout(() => {
                this.mapHeight = this.$refs['journeyDetailsCard'].clientWidth;
            }, 0);
        }
    },
    created() {
        this.adjustMapToWidth();
        window.addEventListener('resize', this.adjustMapToWidth);
    }
};
</script>
<style lang="scss" scoped></style>
